// extracted by mini-css-extract-plugin
module.exports = {"text":"text-regular-m_text__3ieuR"};